import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  selectNotificationEmail,
  selectNotificationInbox,
} from '@app/generated/feature-flags.selectors';

/**
 * `/notifications/email-settings` exists only while `notificationEmail` and its dependency `notificationInbox` are both on
 * (#3942). Otherwise the URL falls through to not-found, as before the route existed; saved preferences are untouched
 * and come back when both flags are on.
 */
export const notificationEmailCanMatch: CanMatchFn = () => {
  const store = inject(Store);
  return (
    store.selectSignal(selectNotificationInbox)() &&
    store.selectSignal(selectNotificationEmail)()
  );
};
